var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-list flex flex-col"},[_vm._t("title",function(){return [_c('div',{staticClass:"font-medium"},[_vm._v(_vm._s(_vm.title))])]}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }